import React, {Component} from 'react';
import {Button, CardBody, Col, Modal, ModalBody, ModalHeader, Row,} from 'reactstrap';
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import * as BB from "../../../../components/BBComponent";
import {timeoutPopup} from "../../../../components/BBComponent";
import Swal from 'sweetalert2';
import {bindActionCreators} from "redux";
import * as taskActions from "../../../../redux/actions/taskActions";
import {withRouter} from "react-router-dom";
import * as loadingActions from "../../../../redux/actions/loadingActions";
import notify from "devextreme/ui/notify";
import {CustomCard} from "../../../../components/custom";
import moment, { lang } from 'moment';
import jwt_decode from 'jwt-decode';
import { data } from 'jquery';
import { callAPI, callApiGet, callApiPost } from "../../../../components/Axios";

let languages = undefined;

class TaskConfirm extends Component
{

   constructor(props)
   { const token = localStorage.getItem("token");
   let user = null;
   if (token) {
      user = jwt_decode(token);
   }
      
      super(props);

      this.state = {
         gridData: [],
         update: false,
         showDetail: false,
         showModal: false,
         selectedDate: undefined,
         selectedUserId: undefined,
         otherConfirm: undefined,
         otherTransfer:false,
         showDeleteModal:false,
         showProcurationModal:false,
         otherConfirmCount: '',
         procurationConfirmCount:'',
         myOwnTaskCount:'',
         loginUser:user,
         isProcuration:undefined,
         isMobile: window.innerWidth <= 768,
         jsonData: [],
         visibleColumns: []
      };
      this.gridRef = React.createRef();
      this.getConfirmation();
      this.getData();
      this.getProcurationConfirmCount();
   }

   getConfirmation()
   {
      BB.FetchJSON('api/OwnConfirmTask/GetConfirmByProcuration').then(res =>
      {
         if (res.length > 0)
         {
            this.setState({
               otherConfirm: res[0],
               selectedUserID: undefined,
               selectedDate: undefined,
            });
         }
         else
         {
            this.setState({
               otherConfirm: undefined,
               selectedUserID: undefined,
               selectedDate: undefined,
            });
         }
      })

     
   }
    fetchJsonValueFromDatabase = async (userID, screenType) => {
        try {
            const response = await fetch(`/api/Task/GetColumnSelectors?userID=${userID}&screenType=${screenType}`);
            if (!response.ok) {
                throw new Error('Veri alınırken hata oluştu');
            }

            const jsonValue = await response.json();
            
            // ✅ Eğer DB'den veri gelmezse (null, boş array, veya JsonValue null), default değerlerle yeni kayıt oluştur
            if (!jsonValue || (Array.isArray(jsonValue) && jsonValue.length === 0) || (Array.isArray(jsonValue) && jsonValue[0] && !jsonValue[0].JsonValue)) {
                console.log('DB\'de kayıt yok veya JsonValue null, default değerler ile yeni kayıt oluşturuluyor...');
                
                const allColumns = [
                    "TaskNumber", "Company", "Department", "DepartmentJob",
                    "Createname", "CategoryName", "DegreeOfUrgency", "Description", "CreateDate",
                    "AdditionalConfirmDescription"
                ];
                
                const defaultVisibility = {
                    "TaskNumber": true,
                    "Company": true,
                    "Department": true,
                    "DepartmentJob": true,
                    "Createname": true,
                    "CategoryName": true,
                    "DegreeOfUrgency": true,
                    "Description": false,
                    "CreateDate": true,
                    "AdditionalConfirmDescription": true
                };
                
                const normalized = {};
                allColumns.forEach((field, idx) => {
                    normalized[field] = {
                        visible: defaultVisibility[field] !== undefined ? defaultVisibility[field] : true,
                        visibleIndex: idx,
                        width: null
                    };
                });
                
                const defaultJsonValue = JSON.stringify(normalized);
                const defaultData = [{
                    JsonValue: defaultJsonValue,
                    IsActive: true
                }];
                
                // DB'ye yeni kayıt ekle
                const payload = {
                    UserID: userID,
                    JsonValue: defaultJsonValue,
                    ScreenType: screenType
                };
                
                try {
                    const saveResponse = await fetch('/api/Task/UpdateColumnChooser', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });
                    
                    if (saveResponse.ok) {
                        console.log('Default kolon ayarları başarıyla DB\'ye kaydedildi');
                    } else {
                        console.error('Default kolon ayarları DB\'ye kaydedilemedi');
                    }
                } catch (saveError) {
                    console.error('DB kayıt hatası:', saveError);
                }
                
                this.setState({ jsonData: defaultData });
                return defaultData;
            }
            
            const normalized = this.normalizeColumnsFromDb('WaitingConfirm', jsonValue);
            this.setState({ jsonData: normalized });
            if (Array.isArray(jsonValue) && Array.isArray(normalized) && jsonValue[0]?.JsonValue !== normalized[0]?.JsonValue) {
                const payload = { UserID: userID, JsonValue: normalized[0].JsonValue, ScreenType: screenType };
                fetch('/api/Task/UpdateColumnChooser', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).catch(() => null);
            }
            return jsonValue;
        } catch (error) {
            console.error("JsonValue alınırken hata oluştu:", error);
            return null;
        }
    };
    normalizeColumnsFromDb = (screenType, dbList) => {
        try {
            if (!Array.isArray(dbList) || dbList.length === 0) return dbList;
            const item = { ...dbList[0] };
            const allColumns = [
                "TaskNumber", "Company", "Department", "DepartmentJob",
                "Createname", "CategoryName", "DegreeOfUrgency", "Description", "CreateDate",
                "AdditionalConfirmDescription"
            ];
            
            // Default görünürlükleri (Default grid'den alındı)
            const defaultVisibility = {
                "TaskNumber": true,
                "Company": true,
                "Department": true,
                "DepartmentJob": true,
                "Createname": true,
                "CategoryName": true,
                "DegreeOfUrgency": true,
                "Description": false,
                "CreateDate": true,
                "AdditionalConfirmDescription": true
            };
            
            const renameMap = {};
            let parsed;
            try { 
                parsed = item.JsonValue ? JSON.parse(item.JsonValue) : null; 
            } catch { 
                // JSON parse hatası - varsayılan değerleri kullan
                return this.createDefaultColumnState(item, allColumns, defaultVisibility);
            }
            
            // JsonValue null ise veya boş obje ise varsayılan değerleri kullan
            if (!parsed || Object.keys(parsed).length === 0) {
                return this.createDefaultColumnState(item, allColumns, defaultVisibility);
            }
            
            // Eski format kontrolü: Tüm değerler boolean ise ve hiçbiri object değilse eski formattır
            const isOldFormat = Object.values(parsed).every(v => typeof v === 'boolean' || v === null || v === undefined);
            
            if (isOldFormat) {
                console.log('Eski format veri tespit edildi, default değerler kullanılıyor');
                return this.createDefaultColumnState(item, allColumns, defaultVisibility);
            }
            
            const normalized = {};
            allColumns.forEach((field, idx) => {
                let v = parsed[field];
                if (v && typeof v === 'object') {
                    normalized[field] = {
                        visible: typeof v.visible === 'boolean' ? v.visible : defaultVisibility[field] || false,
                        visibleIndex: Number.isFinite(v.visibleIndex) ? v.visibleIndex : idx,
                        width: (v.width !== undefined ? v.width : null)
                    };
                } else if (typeof v === 'boolean') {
                    normalized[field] = { 
                        visible: v, 
                        visibleIndex: idx, 
                        width: null 
                    };
                } else {
                    // Kayıt yoksa default görünürlük: Default grid'deki görünürlükleri kullan
                    normalized[field] = { 
                        visible: defaultVisibility[field] !== undefined ? defaultVisibility[field] : true, 
                        visibleIndex: idx, 
                        width: null 
                    };
                }
            });
            item.JsonValue = JSON.stringify(normalized);
            return [item];
        } catch (e) {
            console.error('normalizeColumnsFromDb hatası:', e);
            return dbList;
        }
    }
    
    // Varsayılan kolon durumu oluştur
    createDefaultColumnState = (item, allColumns, defaultVisibility) => {
        const normalized = {};
        allColumns.forEach((field, idx) => {
            normalized[field] = { 
                visible: defaultVisibility[field] !== undefined ? defaultVisibility[field] : true, 
                visibleIndex: idx, 
                width: null 
            };
        });
        item.JsonValue = JSON.stringify(normalized);
        return [item];
    }

    // Legacy localStorage fallback: DB kaydı yoksa eski local grid state'i oku
    loadLegacyColumnsFromLocalStorage = (storageKey) => {
        try {
            const raw = window.localStorage.getItem(storageKey) || window.localStorage.getItem('storage');
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            const columns = parsed?.columns;
            if (!Array.isArray(columns) || columns.length === 0) return null;
            const columnsState = {};
            columns.forEach(col => {
                const dataField = col?.dataField;
                if (!dataField) return;
                columnsState[dataField] = {
                    visible: typeof col.visible === 'boolean' ? col.visible : true,
                    visibleIndex: Number.isFinite(col.visibleIndex) ? col.visibleIndex : null,
                    width: (col.width !== undefined ? col.width : null)
                };
            });
            return [{ JsonValue: JSON.stringify(columnsState), IsActive: true }];
        } catch (e) {
            console.warn('Legacy localStorage okunamadı:', e);
            return null;
        }
    }

    async componentDidMount() {
        await this.getData();        
        const screenType = 'WaitingConfirm';
        const userID = this.state.loginUser.ID;
        const jsonValue = await this.fetchJsonValueFromDatabase(userID, screenType)
        // DB boş ise legacy localStorage fallback uygula (eski kullanıcılar)
        if (!jsonValue || (Array.isArray(jsonValue) && jsonValue.length === 0)) {
            const legacy = this.loadLegacyColumnsFromLocalStorage('dxPoolSettings2');
            if (legacy) {
                this.setState({ jsonData: legacy });
            }
        } else {
            // DB'den veri geldi, jsonData state'i zaten fetchJsonValueFromDatabase içinde set edildi
            console.log('DB\'den veri alındı, jsonData state güncellendi');
        }
    }
    getData() {
        BB.FetchJSON('api/OwnConfirmTask/GetData').then(data => {
            // data'nın bir dizi olup olmadığını kontrol et
            if (Array.isArray(data)) {
                data.map(jsonlar => (
                    this.setState({ isProcuration: jsonlar.IsProcuration })
                ));
            } else {
                console.log('Beklenen dizi verisi alınamadı:', data);
            }
            this.setState({ gridData: data });
        });

        this.getOtherConfirmData();
        this.getMyOwnTaskCount();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize); 
    }
    handleResize = () => {
        this.setState({
            isMobile: window.innerWidth <= 768
        });
    }
   getOtherConfirmData() {
      BB.FetchTEXT('api/OwnConfirmTask/GetProcurationTaskCount').then(data =>
         {
            this.setState({otherConfirmCount: data});
         })

         
   }

   getMyOwnTaskCount() {
      BB.FetchTEXT('api/OwnConfirmTask/GetMyOwnTaskCount').then(data =>
         {
            this.setState({myOwnTaskCount: data});
         })

         
   }

   getProcurationConfirmCount(){

      callAPI(
         callApiGet,
         'api/OwnConfirmTask/GetConfirmTaskCount',
         {},
          (res) => {
           if (res?.data) {
             
            this.setState({procurationConfirmCount: res?.data});
           }
         },
         true
       );






      // BB.FetchTEXT('api/OwnConfirmTask/GetConfirmTaskCount').then(data =>
      //    {
      //       this.setState({procurationConfirmCount: data});
      //    })
   }

  

   handleChange(key, value)
   {
      let taskID = value;

      if (key === 'confirm')
      {
         BB.FetchJSON('api/DataCheck/ConfirmCheck?TaskID=' + taskID).then(res =>
         {
            if (res === true)
            {
               Swal.fire({
                  title: languages.onayAciklamasiGiriniz,
                  input: 'textarea',
                  inputAttributes: {
                     'aria-label': 'Type your message here'
                  },
                  showCancelButton: true,
                  confirmButtonText: languages.onayVer,
                  cancelButtonText: languages.iptal,
                  showLoaderOnConfirm: true,
                  preConfirm: (login) =>
                  {
                     let url = '/api/OwnConfirmTask/Confirm?id=' + taskID + '&Description=' + login;

                     return fetch(url)
                     .then((response) => response.text())
                     .then((res) =>
                     {
                        return res;
                     })
                     .catch((error) =>
                     {
                        console.error(error);
                     });
                  },
                  allowOutsideClick: () => !Swal.isLoading()
               }).then((result) =>
               {
                  
                  if(result.isConfirmed===true && result.value==="false"){
                     timeoutPopup('Talep Daha Önce Onaylanmıştır !', "warning", "Tamam", 4000);

                  }
                  else if (result.isConfirmed)
                  {
                     this.setState({update: !this.state.update}, this.getData);

                     Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: languages.onayBasariylaVerilmistir,
                        showConfirmButton: false,
                        timer: 1500
                     })
                  }
               })
            }
            else
            {
               timeoutPopup('Talebin durumu değiştiği için bu talep üzerinde işlem yapamazsınız!', "warning", "Tamam", 4000);
            }
         })
      }
      if (key === 'reject')
      {
         BB.FetchJSON('api/DataCheck/CancelCheck?TaskID=' + taskID).then(res =>
         {
            if (res === true)
            {
               Swal.fire({
                  title: "Red açıklaması giriniz",
                  input: 'textarea',
                  inputAttributes: {
                     'aria-label': 'Type your message here'
                  },
                  showCancelButton: true,
                  confirmButtonText: "Reddet",
                  cancelButtonText: languages.vazgec,
                  showLoaderOnConfirm: true,
                  preConfirm: (login) =>
                  {
                     let url = '/api/OwnConfirmTask/Reject?id=' + taskID + '&Description=' + login;

                     return fetch(url)
                     .then((response) => response.text())
                     .then((res) =>
                     {
                        return res;
                     })
                     .catch((error) =>
                     {
                        console.error(error);
                     });
                  },
                  allowOutsideClick: () => !Swal.isLoading()
               }).then((result) =>
               {
                  if(result.isConfirmed===true && result.value==="false"){
                     timeoutPopup('Talep Daha Önce Reddedilmiştir !', "warning", "Tamam", 4000);

                  }
                 else if (result.isConfirmed)
                  {
                     this.setState({update: !this.state.update}, this.getData);

                     Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: "Talep Başarıyla reddedilmiştir",
                        showConfirmButton: false,
                        timer: 1500
                     })
                  }
               })
            }
            else
            {
               timeoutPopup('Talebin durumu değiştiği için bu talep üzerinde işlem yapamazsınız!', "warning", "Tamam", 4000);
            }
         })
      }
      if (key === 'selectedDate' || key === 'selectedUserID')
      {
         this.setState({[key]: value});
      }
      if(key=== 'otherTransfer') {
          this.setState({otherTransfer: true})
      }

      if(key=== 'otherTransferNo') {
         this.setState({otherTransfer: false})
     }
   }

   saveConfirmUser()
   {
      let {selectedDate, selectedUserID} = this.state;

      if (selectedDate !== undefined || selectedUserID !== undefined)
      {
         //let expryDate = new Date(selectedDate).toJSON().slice(0, 10);
         let expryDate=moment(selectedDate).format("YYYY-MM-DD 23:59");
         this.props.actions.isLoading(true)

         BB.FetchJSON('api/OwnConfirmTask/SetConfirmByProcuration?strDate=' + expryDate + '&UserID=' + this.state.selectedUserID + '&otherTransfer=' + this.state.otherTransfer)
         .then(r =>
         {
            if (r === true)
            {
               this.setState({
                  selectedUserID: undefined,
                  selectedDate: undefined,
                  showModal: false
               })
            }
            else
            {
               this.setState({
                  selectedUserID: undefined,
                  selectedDate: undefined,
                  showModal: false
               })
            }
            this.getConfirmation();
            this.getData();
                      this.props.actions.isLoading(false)

         })
      }
      else
      {
         notify('Lütfen zorunlu alanları doldurunuz!', 'error', 2000);
      }
   }

   deleteOtherConfirm()
   {
      this.getOtherConfirmData();
      this.setState({showDeleteModal: !this.state.showDeleteModal})
    /*    BB.askYesNo('Vekaleten onay iptali', 'Vekaleten verdiğiniz onay yetkisi kaldırılacaktır, Eminmisiniz?', 'Evet', 'Vazgeç')
      .then(res =>
      {
         if (res === true)
         {
            BB.FetchJSON('api/OwnConfirmTask/DeleteConfirmByProcuration')
            .then(r =>
            {
               this.getConfirmation();
            })
         }
      })  */
   }

   takeProcurationTasks(){
     
         BB.FetchJSON('api/OwnConfirmTask/TaskTransfer?otherTransfer=' + this.state.otherTransfer)
         .then(r =>
         {
            if (r === true)
            {
               this.setState({
                  selectedUserID: undefined,
                  selectedDate: undefined,
                  showDeleteModal: false
               })
            }
            else
            {
               this.setState({
                  selectedUserID: undefined,
                  selectedDate: undefined,
                  showDeleteModal: false
               })
            }
            this.getConfirmation();
            this.getData();
         })
      }
    
    handleSave = async () => {
        if (!this.gridRef || !this.gridRef.current || !this.gridRef.current.instance) {
            console.error("Grid referansı bulunamadı!");
            return;
        }

        const grid = this.gridRef.current.instance;

        const allColumns = [
            "TaskNumber", "Company", "Department", "DepartmentJob",
            "Createname", "CategoryName", "DegreeOfUrgency", "Description", "CreateDate",
            "AdditionalConfirmDescription"
        ];

        const columnsState = {};
        allColumns.forEach((df) => {
            const visible = grid.columnOption(df, "visible");
            const visibleIndex = grid.columnOption(df, "visibleIndex");
            const width = grid.columnOption(df, "width");
            columnsState[df] = {
                visible: typeof visible === 'boolean' ? visible : false,
                visibleIndex: Number.isFinite(visibleIndex) ? visibleIndex : null,
                width: width ?? null
            };
        });

        const payload = {
            UserID: this.state.loginUser.ID,
            JsonValue: JSON.stringify(columnsState),
            ScreenType: 'WaitingConfirm'
        };

        try {
            const response = await fetch('/api/Task/UpdateColumnChooser', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const err = await response.json().catch(() => ({}));
                notify(err?.message || 'Hata', 'error', 3000);
                return;
            }

            notify('Sütunlar Başarıyla Kaydedildi', 'success', 2000);
        } catch (error) {
            console.error("Hata:", error);
            notify('Hata', 'error', 3000);
        }
    };

    onToolbarPreparing = (e) => {
        let ths = this;
        let toolbarItems = e.toolbarOptions.items;
        const { isMobile, loginUser, isProcuration, otherConfirm } = ths.state;
        toolbarItems.push({
            widget: "dxButton",
            options: {
                icon: "save",
                onClick: () => {
                    this.handleSave();
                },
                stylingMode: "outlined",
                type: "default",
                width: 38,
                hint: "Kaydet",
                elementAttr: {
                    class: "custom-save-button",
                    style: "background-color: white !important; border: 1px solid black !important;"
                },
                onRendered: (e) => {
                    const icon = e.element.querySelector(".dx-icon");
                    if (icon) {
                        icon.style.color = "black";
                    }
                },
            },
            location: "after",
        });
        // Toplam Checkbox
        toolbarItems.unshift({
            location: 'center',
            template: 'totalGroupCount'
        });

        // Sayfa Adı
        toolbarItems.unshift({
            location: 'before',
            template: 'pageName'
        });

        if (isProcuration === true) {

        } else if (loginUser.IsManager === "True" && otherConfirm === undefined) {
            toolbarItems.push({
                widget: 'dxButton',
                options: {
                    onClick: () => {
                        this.setState({ showModal: true });
                    },
                    text: languages.vekaletenOnay,
                    width: isMobile ? 100 : 200, 
                    visible: true,
                },
                location: 'after',
            });
        }
    };

   
   toolbarItemRender = (e) =>
   {
      const isMobile = window.innerWidth <= 768;
       return (
           isMobile ? (
               <div style={{
                   width: '150px', height: '70px', textAlign: 'center', color: 'white', margin: '0px -100px 0px 125px', float: 'none'
               }}>
                   <span className="name">
                       {languages.toplamTalepSayisi} {this.state.gridData.length}</span>
                       <br/>
               </div>
           ) : (
                   <div className="informer">
                       <h3 className="count">{this.state.gridData.length}</h3>
                       <span className="name">{languages.toplamTalepSayisi}</span>
                   </div>
           )
      );
   }


   pageNameRender = (e) =>
   {
      return (
         <div className="informer">
            <strong><h5 className="count" style={{marginTop: 7, marginLeft: -60,width: 250}}>{languages.onaybekleyentalepler}</h5></strong>
         </div>
      );
   }
    getVisibleColumns = () => {
        const gridInstance = this.gridRef.current?.instance;  
        if (!gridInstance) return [];
        const columns = gridInstance.getVisibleColumns();  
        return columns;
    };
   render()
   {    
       const { t } = this.props;
       const { jsonData } = this.state;
       const visibleColumns = jsonData.map(item => {
           try {
               return {
                   field: JSON.parse(item.JsonValue),
                   visible: item.IsActive
               };
           } catch (error) {
               console.error("JSON parse hatası:", error);
               return {
                   field: {},
                   visible: false
               };
           }
       });
      const { isMobile } = this.state;
      languages = {
         onayAciklamasiGiriniz: t('onayAciklamasiGiriniz'),
         onayVer: t('onayVer'),
         iptal: t('iptal'),
         onayBasariylaVerilmistir: t('onayBasariylaVerilmistir'),
         iptalAciklamasiGiriniz: t('iptalAciklamasiGiriniz'),
         vazgec: t('vazgec'),
         talepBasariylaIptalEdilmistir: t('talepBasariylaIptalEdilmistir'),
         onaybekleyentalepler:t('onaybekleyentalepler'),
         toplamTalepSayisi:t('toplamTalepSayisi'),
         bilgi:t("bilgi"),
         vekaletenOnay:t("vekaletenOnay"),
         sonGecerlilikTarihiSeciniz:t("sonGecerlilikTarihiSeciniz"),
         LütfenSeçiniz:t("LütfenSeçiniz"),
         sizinYerinizeOnayVerecekKisiSeciniz:t("sizinYerinizeOnayVerecekKisiSeciniz"),
         kaydet:t("kaydet"),
         vazgec:t("vazgec")
      }
     
      return (
         <>
            <Row>
               <Col xs="12" sm="12">
                  <CustomCard cardStyle='card-dashboard-calendar pb-0'>
                          <CardBody>
                              {Array.isArray(visibleColumns) && visibleColumns.length > 0 ? (
                                  BB.DxDataGridWithDetailForConfirm(
                                      this.gridRef,
                                      this.state.gridData,
                                      this,
                                      this.state.showDetail,
                                      isMobile,
                                      visibleColumns
                                  )
                              ) : (
                                  BB.DxDataGridWithDetailForConfirmDefault(
                                      this.state.gridData,
                                      this,
                                      this.state.showDetail,
                                      isMobile    
                                  )
                              )}
                     </CardBody>

                     {this.state.otherConfirm !== undefined &&
                     <div>
                        <strong>
                           {languages.bilgi}
                        </strong>
                        {new Date(this.state.otherConfirm.ExpiryDate).toLocaleDateString()} Tarihine kadar sizin
                        yerinize <strong> {this.state.otherConfirm.Name}</strong> onay verecektir

                        <div
                           style={{float: "right", right: 0, color: 'mediumblue', cursor: 'pointer'}}
                           onClick={() => this.deleteOtherConfirm()}
                        >
                           Kaldır
                        </div>
                     </div>
                     }
                  </CustomCard>
               </Col>
            </Row>
            <Modal
               toggle={() => this.setState({showDeleteModal: false})}
               backdrop={true}
               isOpen={this.state.showDeleteModal}
               centered={true}
            >
               <ModalHeader toggle={() => this.setState({showDeleteModal: false})}>
                  Vekaleten Onay İptali
               </ModalHeader>
               <ModalBody>

               <h3 className="count">{t("vekaletenverdiginizonayyetkisikaldirilacaktir")}</h3>
                  {
                     this.state.otherConfirmCount > 0 &&   <h5 className="count">{t("vekaletenonayibekleyen")} {this.state.otherConfirmCount} {t("adetonaylanmamistalepbulunmaktadir")}</h5>
                  }
                  {
                     this.state.otherConfirmCount > 0 && <div className='row'> <div className='col-md-2'> {BB.CheckBoxWithLabel('otherTransfer', t("evet"), this) }</div> <div className='col-md-10'> {BB.CheckBoxWithLabel('otherTransferNo', t("hayır"), this) }</div> </div>
                  }
                  
                  <Button
                     color={'success'}
                     style={{float: 'right'}}
                     onClick={() => this.takeProcurationTasks()}
                  >
                     Evet
                  </Button>

                  <Button
                     color={'primary'}
                     style={{float: 'right', marginRight: 10}}
                     onClick={() => this.setState({
                        selectedDate: undefined,
                        selectedUserID: undefined,
                        showDeleteModal: false
                     })}
                  >
                     {languages.vazgec}
                  </Button>
               </ModalBody>

            </Modal>

           

            <Modal
               toggle={() => this.setState({showModal: false})}
               backdrop={true}
               isOpen={this.state.showModal}
               centered={true}
            >
               <ModalHeader toggle={() => this.setState({showModal: false})}>
                  {languages.vekaletenOnay}
               </ModalHeader>
               <ModalBody>
                  {BB.DateSelectWithLabel('selectedDate', languages.sonGecerlilikTarihiSeciniz, this, languages.LütfenSeçiniz)}
                  {BB.DxDropDownWithURL('selectedUserID', languages.sizinYerinizeOnayVerecekKisiSeciniz, this, 'api/OwnConfirmTask/GetDepartmentUser', languages.LütfenSeçiniz)}
                  {
                     this.state.myOwnTaskCount > 0 &&  <h5 className="count">{t("onayiniziBekleyen")} {this.state.myOwnTaskCount} {t("adetonaylanmamistalep")}</h5>
                  }
                   
                   
                   {
                      this.state.myOwnTaskCount >0 && <div className='row'> <div className='col-md-2'> {BB.CheckBoxWithLabel('otherTransfer', t("evet"), this) }</div> <div className='col-md-10'> {BB.CheckBoxWithLabel('otherTransferNo', t("hayır"), this) }</div> </div>
                   }
                   
                    
                   {
                      this.state.procurationConfirmCount > 0 && <h5 style={{color:'red'}}>{t("vekaletenonayibekleyen")} {this.state.procurationConfirmCount} {t("adetonaylanmamistalepbulunmaktadirdegerlendiriniz")}</h5>
                   }
                   
                  <Button
                     color={'success'}
                     style={{float: 'right'}}
                     onClick={() => this.saveConfirmUser()}
                  >
                     {languages.kaydet}
                  </Button>

                  <Button
                     color={'primary'}
                     style={{float: 'right', marginRight: 10}}
                     onClick={() => this.setState({
                        selectedDate: undefined,
                        selectedUserID: undefined,
                        showModal: false
                     })}
                  >
                     {languages.vazgec}
                  </Button>
               </ModalBody>

            </Modal>
         </>
      );
   }
}

function mapStateToProps(state)
{
   return {
      
      loginUser: state.loginReducer,
      ownConfirm: state.ownConfirmReducer,
   }
}

function mapDispatchToProps(dispatch)
{
   return {
      actions: {
         // getOwnConfirm: bindActionCreators(taskActions.getOwnConfirmTask, dispatch),
         isLoading: bindActionCreators(loadingActions.setLoading, dispatch),
      }
   }
}

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TaskConfirm)))


